import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import Button from '../buttons/Button'

const NavItem = styled.li`
  list-style: none;
  text-align: left;
  // padding: 0rem 1rem;
  border-bottom: 1px solid #F8F8F8;
  background: #fff;

  &:last-child, &:first-child {
    border: none;
    // padding: 0.4rem 1rem;
  }

  a {
    display: block;
    margin: 0;
    border-radius: 0;
  }

  @media (min-width: 800px) {
    text-align: center;
  }
`

const DropdownNavClass = css`  
  @media (min-width: 800px) {
    pointer-events: none;
    transition: .2s ease-out;
    opacity: 0;
    box-shadow: 0 1px 4px rgba(53,57,71,.3);
    position: absolute;
    display: flex;
    flex-direction: column;
    min-width: 300px;
    right: -50px;
    top: 3.3rem;
  }
`

const Wrapper = styled.div`
  position: relative;

  &:hover, &:focus {
    .${DropdownNavClass} {
      pointer-events: all;
      opacity: 1;
    }
  }
`

class NavDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() {
    const {
      label,
      links
    } = this.props.nav
    return (
      <Wrapper>
        <Button anchor navLink to={`#`}>{label}</Button>
        <nav className={DropdownNavClass}>
          {links.map((link, idx) => (
            <NavItem key={idx}>
              <Button
                anchor
                navLink
                external={link.external}
                to={link.to}
                icon="arrow_right_alt"
                onClick={() => (this.props.onNavigate && this.props.onNavigate()) }
              >{link.label}</Button>
            </NavItem>
          ))}
        </nav>
      </Wrapper>
    );
  }
}
 
export default NavDropdown;


// WEBPACK FOOTER //
// ./src/components/header/NavDropdown.js